import * as types from './mutation-types';

export default {
  setCurrentTime({ commit }, payload) {
    commit(types.SET_CURRENT_TIME, payload);
  },

  setUserTime({ commit }, payload) {
    commit(types.SET_USER_TIME, payload);
  },

  reset({ commit }) {
    commit(types.RESET_CURRENT_TIME);
  },
};
